import { render } from "./DipIn.vue?vue&type=template&id=5388c8ee&scoped=true"
import script from "./DipIn.vue?vue&type=script&lang=js"
export * from "./DipIn.vue?vue&type=script&lang=js"

import "./DipIn.vue?vue&type=style&index=0&id=5388c8ee&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5388c8ee"]])

export default __exports__